// extracted by mini-css-extract-plugin
export var active = "_fh-2";
export var recordingDot = "_fh-1";
export var recordingIndicator = "_fh-0";